const isPromise = test => test instanceof Promise

export default isPromise
